// Mock data for Barros & Durães Advogados website

export const mockData = {
  // Company Information
  company: {
    name: "Barros & Durães Advogados",
    tagline: "Rigor, Proximidade e Soluções Jurídicas Eficazes",
    description: "A Barros & Durães Advogados presta um acompanhamento jurídico claro, próximo e seguro, orientado para a resolução eficaz das questões dos seus clientes.",
    address: "Rua São João de Sobrado 5049, 4440-339 Sobrado",
    email: "barrosduraesadvogados@gmail.com",
    logoUrl: "https://customer-assets.emergentagent.com/job_barros-duraes-law/artifacts/7a8hnrwa_image.png"
  },

  // About Us
  aboutUs: {
    title: "Sobre Nós",
    content: [
      "A Barros & Durães Advogados é um escritório orientado para a prestação de um acompanhamento jurídico claro, próximo e seguro, centrado na resolução eficaz das questões que lhe são confiadas.",
      "Fundado pela Dra. Stéphanie Barros e pela Dra. Márcia Durães, o escritório pauta a sua atuação pelo rigor técnico, pela responsabilidade e por uma abordagem prática do Direito, ajustada à realidade de cada cliente.",
      "Prestamos assessoria jurídica a clientes particulares e empresariais, nacionais e estrangeiros, intervindo em diversas áreas do Direito, de acordo com as necessidades específicas de cada situação.",
      "Privilegiamos uma atuação transparente e objetiva, garantindo que cada cliente compreende o seu enquadramento jurídico, os riscos envolvidos e as soluções disponíveis.",
      "Cada processo é acompanhado de forma individualizada, com proximidade, organização e sentido de compromisso, tendo sempre como objetivo a obtenção de soluções concretas e juridicamente sustentadas.",
      "A Barros & Durães Advogados afirma-se como um escritório comprometido com uma prática jurídica consistente, acessível e orientada para resultados."
    ]
  },

  // Practice Areas
  practiceAreas: [
    {
      id: 1,
      title: "Direito Migratório e da Nacionalidade",
      description: "Acompanhamento completo em processos de regularização, vistos, autorizações de residência e nacionalidade portuguesa."
    },
    {
      id: 2,
      title: "Direito Penal",
      description: "Defesa e assistência em processos criminais, garantindo a proteção dos direitos e interesses dos nossos clientes."
    },
    {
      id: 3,
      title: "Direito Comercial e Societário",
      description: "Consultoria na constituição, gestão e reestruturação de sociedades comerciais e apoio em operações empresariais."
    },
    {
      id: 4,
      title: "Direito do Trabalho",
      description: "Assessoria jurídica em relações laborais, contratos de trabalho, despedimentos e litígios laborais."
    },
    {
      id: 5,
      title: "Contraordenações e Multas",
      description: "Defesa em processos contraordenacionais e impugnação de coimas e sanções administrativas."
    },
    {
      id: 6,
      title: "Registos e Notariado",
      description: "Apoio em atos notariais, registos prediais, comerciais e automóveis, garantindo segurança jurídica."
    },
    {
      id: 7,
      title: "Direito da Família e Menores",
      description: "Acompanhamento em processos de divórcio, regulação de responsabilidades parentais e questões familiares."
    },
    {
      id: 8,
      title: "Direito Administrativo",
      description: "Representação em processos administrativos, impugnações e relações com a Administração Pública."
    },
    {
      id: 9,
      title: "Recuperação de Créditos",
      description: "Ações de cobrança de dívidas e procedimentos extrajudiciais e judiciais de recuperação de créditos."
    },
    {
      id: 10,
      title: "Contratos",
      description: "Elaboração, revisão e negociação de contratos comerciais, civis e empresariais."
    }
  ],

  // Team Members
  team: [
    {
      id: 1,
      name: "Dra. Márcia Durães",
      role: "Advogada Co-Fundadora",
      image: "https://customer-assets.emergentagent.com/job_barros-duraes-law/artifacts/20wo7idu_image.png",
      bio: "Licenciada em Direito pela Universidade Portucalense e em Solicitadoria pelo Politécnico do Porto. Atua nas áreas de Direito Migratório, Direito da Família e Direito Societário. Destaca-se pela organização, rigor e acompanhamento próximo ao cliente.",
      specializations: ["Direito Migratório", "Direito da Família", "Direito Societário"],
      email: "marciaduraes-70732p@adv.oa.pt",
      phone: "913 873 282"
    },
    {
      id: 2,
      name: "Dra. Stéphanie Barros",
      role: "Advogada Co-Fundadora",
      image: "https://customer-assets.emergentagent.com/job_barros-duraes-law/artifacts/olvs4qej_image.png",
      bio: "Licenciada em Solicitadoria e Direito. Atua principalmente nas áreas de Direito do Trabalho e Direito da Família. Destaca-se pelo profissionalismo, ética e abordagem humanizada, com foco na defesa eficaz dos interesses dos clientes.",
      specializations: ["Direito do Trabalho", "Direito da Família"],
      email: "sbarros-70738p@adv.oa.pt",
      phone: "923 127 828"
    }
  ],

  // Testimonials
  testimonials: [
    {
      id: 2,
      name: "Ruth Costa",
      text: "A Dra. Márcia Durães tem acompanhado o processo de regularização da minha família em Portugal com elevado rigor, disponibilidade e atenção ao detalhe. Estamos muito gratos pelo apoio prestado.",
      lawyer: "Dra. Márcia Durães"
    },
    {
      id: 3,
      name: "Diana Moreira",
      text: "A Dra. Stéphanie Barros demonstrou um elevado profissionalismo no acompanhamento de uma situação particularmente delicada da minha vida, tratando todo o processo com competência, sensibilidade e dedicação. Recomendo vivamente.",
      lawyer: "Dra. Stéphanie Barros"
    },
    {
      id: 4,
      name: "Comply Consultoria",
      text: "Gostaria de destacar o excelente trabalho realizado pela advogada de imigração Dra. Márcia Durães, cuja colaboração tem sido fundamental para o sucesso da empresa. Sua dedicação, conhecimento técnico e atenção aos detalhes fazem toda a diferença nos processos, garantindo segurança e eficiência em cada etapa. Além disso, sua postura profissional, disponibilidade e capacidade de comunicação contribuem para um ambiente de trabalho mais organizado e confiável. É uma profissional altamente competente, que agrega grande valor à equipe e à empresa como um todo.",
      lawyer: "Dra. Márcia Durães"
    }
  ],

  // Images
  images: {
    hero: "https://customer-assets-agu9un31.emergentagent.net/job_barros-duraes-law/artifacts/qe6ntjah_Site%20Marcia.jpeg",
    about: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&h=600&fit=crop",
    testimonialsPattern: "https://images.unsplash.com/photo-1566305977571-5666677c6e98?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwdGV4dHVyZXxlbnwwfHx8fDE3NzQ4NzgzNzd8MA&ixlib=rb-4.1.0&q=85"
  }
};
